import React from 'react'

const SubmissionPortal = () => {
  return (
    <div>SubmissionPortal</div>
  )
}

export default SubmissionPortal;